import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/developer/ui/dictionaries")({
    beforeLoad: () => {
        throw redirect({ to: "/design/components/dictionaries", replace: true });
    },
});
